import React from 'react';
import Text from '../../../../components/Typography/Text';
import Checkbox from '../../../../components/Misc/Checkbox';
import FormAccountAddress from './FormAccountAddress';
import FormAccountContactAndName from './FormAccountContactAndName';
import { useAccountContext } from '../Data/accountContext';

export default function FormAccountOwnerJoint({ validation }) {
  const { account, setAccount, isBussinessAccount } = useAccountContext();

  const handleCopyPrimaryAddress = (e) => {
    const checked = e.target.checked;
    const copy = { ...account };

    copy.jointOwner.address1 = checked ? account?.primaryOwner?.address1 : '';
    copy.jointOwner.address2 = checked ? account?.primaryOwner?.address2 : '';
    copy.jointOwner.city = checked ? account?.primaryOwner?.city : '';
    copy.jointOwner.state = checked ? account?.primaryOwner?.state : '';
    copy.jointOwner.country = checked ? account?.primaryOwner?.country : '';
    copy.jointOwner.zip = checked ? account?.primaryOwner?.zip : '';

    setAccount(copy);
  };

  return (
    <div>
      <Text mt={40} variant="h3" label="Co-Applicant" />
      <FormAccountContactAndName objectName="jointOwner" validation={validation} />
      <Checkbox
        mt={30}
        ml={-3}
        mb={20}
        name="idAddress"
        label="Same address of primary applicant"
        checked={
          account.jointOwner.address1 === account.primaryOwner.address1 &&
          account.jointOwner.address2 === account.primaryOwner.address2 &&
          account.jointOwner.city === account.primaryOwner.city &&
          account.jointOwner.state === account.primaryOwner.state &&
          account.jointOwner.country === account.primaryOwner.country &&
          account.jointOwner.zip === account.primaryOwner.zip
        }
        onChange={handleCopyPrimaryAddress}
      />
      <FormAccountAddress
        validation={validation}
        isBusinessAddress={isBussinessAccount()}
        objectName="jointOwner"
      />
    </div>
  );
}
